import { createFileRoute } from '@tanstack/react-router';
import { DepositSettingsPage } from '@/features/catalog/deposit-settings-page.js';

export const Route = createFileRoute('/_app/settings/deposit-settings')({
  component: DepositSettingsPage,
});
